import { MissionPayrollBreakdownFieldsFragment } from "../../../__generated__/operations/graphql";
import React, { useMemo } from "react";
import { useI18n } from "../../../hooks/i18n-hooks";
import VStack from "../../../ui_atoms/VStack";
import { minutesAsString } from "../../../utils";
import { useTheme } from "../../../hooks/use-theme";
import LabelValueText from "../../LabelValueText";

type PayrollBreakdownHourlyInfoProps = {
    payrollBreakdown: MissionPayrollBreakdownFieldsFragment;
    disabled?: boolean;
};

const PayrollBreakdownHourlyInfo: React.FC<PayrollBreakdownHourlyInfoProps> = ({
    payrollBreakdown,
    disabled = false,
}) => {
    const i18n = useI18n();
    const { fonts } = useTheme();
    const cells = useMemo(() => {
        const result = [];
        const deltaWork = payrollBreakdown.deltaWork || 0;
        if (deltaWork < 0) {
            result.push({
                title: i18n.t("payroll_breakdown.field_delta_work_mode_minus"),
                value: minutesAsString(Math.abs(deltaWork), {
                    separator: "h",
                }),
            });
        } else {
            result.push({
                title: i18n.t("payroll_breakdown.field_delta_work_mode_plus"),
                value: minutesAsString(Math.abs(deltaWork), {
                    separator: "h",
                }),
            });
        }

        if ((payrollBreakdown.totalWork115 || 0) > 0) {
            result.push({
                title: i18n.t("payroll_breakdown.overtime_plus_15"),
                value: minutesAsString(payrollBreakdown.totalWork115 || 0, {
                    separator: "h",
                }),
            });
        }
        if ((payrollBreakdown.totalWork125 || 0) > 0) {
            result.push({
                title: i18n.t("payroll_breakdown.overtime_plus_25"),
                value: minutesAsString(payrollBreakdown.totalWork125 || 0, {
                    separator: "h",
                }),
            });
        }
        if ((payrollBreakdown.totalWork150 || 0) > 0) {
            result.push({
                title: i18n.t("payroll_breakdown.overtime_plus_50"),
                value: minutesAsString(payrollBreakdown.totalWork150 || 0, {
                    separator: "h",
                }),
            });
        }
        if ((payrollBreakdown.totalWork200 || 0) > 0) {
            result.push({
                title: i18n.t("payroll_breakdown.overtime_plus_100"),
                value: minutesAsString(payrollBreakdown.totalWork200 || 0, {
                    separator: "h",
                }),
            });
        }
        return result;
    }, [
        payrollBreakdown.deltaWork,
        i18n,
        payrollBreakdown.totalWork115,
        payrollBreakdown.totalWork125,
        payrollBreakdown.totalWork150,
        payrollBreakdown.totalWork200,
    ]);
    return (
        <VStack style={{ opacity: disabled ? 0.3 : 1.0 }} gap={0.25}>
            {cells.map((item) => (
                <LabelValueText
                    key={item.title}
                    label={item.title}
                    value={disabled ? "--" : item.value}
                    valueStyle={fonts.bodyLarge}
                />
            ))}
        </VStack>
    );
};

export default PayrollBreakdownHourlyInfo;
